// create correctStim property for the global object
window.correctStim = undefined;
window.stimKeyDict = [];

function isStimKey(key){
    // stimX (with possible spaces around)
    const regex = new RegExp(/stim\s*[0-9]+\s*/gmi);
    return regex.test(key);
}

function getStimKeyIndex(key){
    //key is going to be stimX we need X
    // It also handles spaces around the X
    const stimIndex = parseInt(key.substr(4));
    return stimIndex;
}

// Set the correct stim for the current trial as property for the window
function initCorrectStim(){
    const key = window.columnForTrial('key', window.trialRow);
    window.correctStim = getStimKeyIndex(key);
}

function getResponseForStimX(key) {
    if(!shouldRandomizeStimOrder(window.trialRow)) {
        return parseInt(key.substr(4), 10);
    }

    return stimKeyDict[key.substr(4)];
} 